import * as React from 'react';

// Create a React ref for tracking whether or not a component is "mounted" (i.e., the component has been rendered).
// Useful for writing code in a function component that only executes once prior to the first render.
export function useIsMounted() {
  const isMounted = React.useRef(false);
  React.useEffect(() => {
    isMounted.current = true;
    return () => isMounted.current = false;
  }, []);
  return isMounted.current;
}
